<template>
  <div>
    <span v-if="!editMode">
      <i @click="copyToClipBoard" v-if="!noCopy" class="el-icon-copy-document text-info mr-2" style="cursor: pointer"></i>
      <i @click="fucusIn" v-if="!noEdit" class="el-icon-edit text-info mr-2" style="cursor: pointer"></i>

      <span class="copy-to-target" v-if="viewMode == 'text'">{{ cellValue }}</span>
      <vlink class="copy-to-target" :text="linkText || cellValue" :url="cellValue"  v-if="viewMode == 'link'"></vlink>
    </span>
    <div class="editing-mode-container" :style="editContainerStyle"  v-else>
      <i @click="returnToOriginal" class="el-icon-circle-close text-danger mr-2"></i>
      <el-input :style="'width:' +  inputWidth" @input="change" placeholder="" ref="input" size="mini"
                v-model="cellValue"></el-input>
      <el-button @click="saveNewValue" circle class="ml-2" icon="el-icon-check" size="mini" type="success"
                 v-if="saveIsActive"></el-button>
      <!--  <el-button v-if="saveIsActive" @click="returnToOriginal" class="ml-2" type="danger" icon="el-icon-close" circle size="mini"></el-button>-->
    </div>
  </div>
</template>

<script>


export default {
  components: {
    vlink: () => import('@/components/link/View')
  },
  props: {
    linkText: {
      default: false
    },
    viewMode: {
      default: 'text'
    },
    noEdit: {
      default: false
    },
    noCopy: {
      default: false
    },
    inputValue: {
      required: true
    },
    saveAction: {
      required: true
    },
    fieldName: {
      required: true
    },
    customParams: {
      required: false,
      default: {}
    },
    editContainerStyle: {
      required: false,
      default: ""
    },
    inputWidth: {
      required: false,
      default: '120px'
    }
  },
  data() {
    return {
      editMode: false,
      cellValue: '',
      originalValue: 0.00,
      saveIsActive: false,
    }
  },
  beforeMount() {
    this.cellValue = this.inputValue;
    this.originalValue = this.inputValue;
  },
  methods: {
    copyToClipBoard() {
      let copyText = this.$el.getElementsByClassName('copy-to-target')[0]
      const el = document.createElement('textarea');
      el.value = copyText.innerText;
      document.body.appendChild(el);
      el.select();
      if (document.execCommand('copy')) {
        this.$notify({
          title: 'Copied to clipboard',
          type: 'success',
          showClose: false,
          duration: 1000
        });
      }
      document.body.removeChild(el);
    },
    fucusIn() {
      this.editMode = true
      $vue.nextTick(() => {
        this.$refs['input'].focus()
      })
    },
    fucusout() {
      this.returnToOriginal()
    },
    returnToOriginal() {
      this.editMode = false
      this.cellValue = this.originalValue
      this.saveIsActive = false
    },
    saveNewValue() {
      this.saveAction(this.customParams, this.cellValue, () => {
        this.editMode = false
        this.originalValue = this.cellValue
        this.saveIsActive = false
      }, this.fieldName)
    },
    change(val) {
      if (this.originalValue !== this.cellValue) {
        this.saveIsActive = true
      } else {
        this.saveIsActive = false
      }

    }
  }
}
</script>

<style scoped>
.editing-mode-container {
  position: relative;
  z-index: 1000;
  display: inline-block;
}
</style>
